<div class="input-container">
    <label for="uploads_dropbox_access_token" trans>Access Token</label>
    <input type="text" id="uploads_dropbox_access_token" name="uploads_dropbox_access_token" [(ngModel)]="state.server['uploads_dropbox_access_token']" required>
</div>

<div class="input-container">
    <label for="uploads_dropbox_root" trans>Root Directory</label>
    <input type="text" id="uploads_dropbox_root" name="uploads_dropbox_root" [(ngModel)]="state.server['uploads_dropbox_root']" placeholder="/">
</div>